import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as config from '../../assets/config.json';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  public config = config;
  public newVersion: string = '';
  public newVersionAvailable: boolean = false;

  constructor(private http: HttpClient) {}

  public getVersion(): Observable<any> {
    return this.http.get('/assets/config.json?v=' + new Date().getTime()).pipe(
      catchError((error: any) => {
        console.error('Não foi possível verificar o arquivo de versão.');
        return of(null);
      })
    );
  }
}
